type WorkflowStatus =
  | "unsubmitted"
  | "rejected"
  | "submitted"
  | "approved"
  | "billed"
  | "paid"

interface StatusFields {
  submitted?: boolean
  approved?: boolean
  billed?: boolean
  paid?: boolean
  was_rejected?: boolean
}

const STATUS_CONFIG: Record<
  WorkflowStatus,
  { label: string; className: string }
> = {
  paid: {
    label: "Paid",
    className:
      "bg-hpi-dark-green/20 text-hpi-dark-green rounded px-2 py-1 text-xs",
  },
  billed: {
    label: "Billed",
    className: "bg-hpi-light-blue text-hpi-dark-blue rounded px-2 py-1 text-xs",
  },
  approved: {
    label: "Approved",
    className: "bg-hpi-yellow/30 text-hpi-dark-gray rounded px-2 py-1 text-xs",
  },
  submitted: {
    label: "Submitted",
    className: "bg-hpi-pale-gray text-hpi-dark-gray rounded px-2 py-1 text-xs",
  },
  rejected: {
    label: "Rejected",
    className:
      "rounded border border-red-300 bg-red-50 px-2 py-1 text-xs text-red-700",
  },
  unsubmitted: {
    label: "Unsubmitted",
    className:
      "rounded border border-orange-300 bg-orange-50 px-2 py-1 text-xs text-orange-700",
  },
}

export function deriveWorkflowStatus(entry: StatusFields): WorkflowStatus {
  if (entry.paid) return "paid"
  if (entry.billed) return "billed"
  if (entry.approved) return "approved"
  if (entry.submitted) return "submitted"
  if (entry.was_rejected) return "rejected"
  return "unsubmitted"
}

export function WorkflowStatusBadge({ status }: { status: WorkflowStatus }) {
  const config = STATUS_CONFIG[status]
  return <span className={config.className}>{config.label}</span>
}

export function isActionableStatus(status: WorkflowStatus): boolean {
  return status === "unsubmitted" || status === "rejected"
}

export type { StatusFields, WorkflowStatus }
